import { useState, useEffect } from "react"
import { TEAMS } from "./nodes/teams"

// Get all team keys
const TEAM_KEYS = Object.keys(TEAMS)

export function useTeamFilters() {
  const [activeTeams, setActiveTeams] = useState(() => {
    try {
      const saved = localStorage.getItem("insightsTeamFilters")
      return saved ? JSON.parse(saved) : TEAM_KEYS
    } catch {
      return TEAM_KEYS
    }
  })

  useEffect(() => {
    localStorage.setItem("insightsTeamFilters", JSON.stringify(activeTeams))
  }, [activeTeams])

  const toggleTeam = (team) => {
    setActiveTeams((prev) =>
      prev.includes(team) ? prev.filter((t) => t !== team) : [...prev, team]
    )
  }

  const showAll = () => setActiveTeams(TEAM_KEYS)
  const hideAll = () => setActiveTeams([])

  return { activeTeams, toggleTeam, showAll, hideAll, allTeams: TEAM_KEYS }
}

// Team name display mapping
const TEAM_NAMES = {
  payments: "Payments",
  checkout: "Checkout",
  billing: "Billing",
  growth: "Growth",
  platform: "Platform",
  core: "Core",
}

export default function TeamFilter({ activeTeams, onToggle, onShowAll }) {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    try {
      return localStorage.getItem("teamFilterCollapsed") === "true"
    } catch {
      return false
    }
  })

  const toggleCollapse = () => {
    const newState = !isCollapsed
    setIsCollapsed(newState)
    localStorage.setItem("teamFilterCollapsed", String(newState))
  }

  const allActive = activeTeams.length === TEAM_KEYS.length
  const noneActive = activeTeams.length === 0

  return (
    <div className={`filter-panel team-filter-panel ${isCollapsed ? "collapsed" : ""}`}>
      <button
        type="button"
        className="filter-panel-header"
        onClick={toggleCollapse}
      >
        <span className="filter-panel-title">Teams</span>
        {isCollapsed && <span className="filter-panel-badge">{activeTeams.length}/{TEAM_KEYS.length}</span>}
        <span className="filter-panel-chevron">{isCollapsed ? "+" : "-"}</span>
      </button>
      {!isCollapsed && (
        <div className="filter-panel-content">
          <div className="team-filter-actions">
            <button
              type="button"
              className="team-filter-toggle"
              onClick={onShowAll}
            >
              {allActive ? "Hide All" : "Show All"}
            </button>
          </div>
          <div className="team-filter-buttons">
            {TEAM_KEYS.map((team) => {
              const isActive = activeTeams.includes(team)
              const color = TEAMS[team]
              return (
                <button
                  key={team}
                  type="button"
                  className={`team-btn ${isActive ? "active" : ""}`}
                  style={{
                    borderColor: color,
                    backgroundColor: isActive ? color : "white",
                    color: isActive ? "white" : color,
                  }}
                  onClick={() => onToggle(team)}
                >
                  {TEAM_NAMES[team] || team}
                </button>
              )
            })}
          </div>
          <div className="team-filter-status">
            {allActive
              ? "All teams"
              : noneActive
              ? "None"
              : `${activeTeams.length} team(s)`}
          </div>
        </div>
      )}
    </div>
  )
}
